<template>
  <div class="xv_view" id="Offices">
    <div class="xv_top">
      <div>
        <label class="xv_view_title">Offices</label>
      </div>
      <div class="xv_actions">
        <button class="sec_btn m_r" @click="import_office()">
          Import
          <span class="mdi mdi-cloud-download-outline"></span>
        </button>
        <button class="main_btn" @click="add_office()">
          New Office
          <span class="mdi mdi-plus-thick"></span>
        </button>
      </div>
    </div>
    <div class="xv_table">
      <div class="xv_table_title">
        <div>
          <span>Offices (7)</span>
        </div>
        <div class="table_search">
          <span class="mdi mdi-magnify"></span>
          <input type="text" placeholder="Search by Office" />
        </div>
      </div>
      <table class="office_table">
        <thead>
          <tr>
            <th style="width:20%">Name</th>
            <th style="width:16%;text-align:center">Country</th>
            <th style="width:16%;text-align:center">City</th>
            <th style="width:16%;text-align:center">Employees</th>
            <th style="width:16%;text-align:center">Status</th>
            <th style="width:16%;text-align:center">Alerts</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span id="Microsoft" @click="view_office">Microsoft</span>
            </td>
            <td>
              <span>United States</span>
            </td>
            <td>
              <span>Hougang</span>
            </td>
            <td>
              <span>30</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
            <td>
              <span>3</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="Apple" @click="view_office">Apple</span>
            </td>
            <td>
              <span>United States</span>
            </td>
            <td>
              <span>Tampines</span>
            </td>
            <td>
              <span>22</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
            <td>
              <span>8</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="Nestle" @click="view_office">Nestle</span>
            </td>
            <td>
              <span>Switzerland</span>
            </td>
            <td>
              <span>Pasir Ris</span>
            </td>
            <td>
              <span>32</span>
            </td>
            <td class="status_2">
              <span>Closed</span>
            </td>
            <td>
              <span>12</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="Alphabet" @click="view_office">Alphabet</span>
            </td>
            <td>
              <span>United States</span>
            </td>
            <td>
              <span>Yishun</span>
            </td>
            <td>
              <span>18</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
            <td>
              <span>3</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="Facebook" @click="view_office">Facebook</span>
            </td>
            <td>
              <span>United States</span>
            </td>
            <td>
              <span>Tampines</span>
            </td>
            <td>
              <span>22</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
            <td>
              <span>8</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="Alibaba" @click="view_office">Alibaba</span>
            </td>
            <td>
              <span>Greater China</span>
            </td>
            <td>
              <span>Hougang</span>
            </td>
            <td>
              <span>30</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
            <td>
              <span>3</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="Tencent" @click="view_office">Tencent</span>
            </td>
            <td>
              <span>Greater China</span>
            </td>
            <td>
              <span>Pasir Ris</span>
            </td>
            <td>
              <span>32</span>
            </td>
            <td class="status_2">
              <span>Closed</span>
            </td>
            <td>
              <span>12</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Add office modal -->
    <modal name="add_office" transition="pop-out" :width="600" height="auto">
      <addOffice></addOffice>
    </modal>
    <!-- Import office modal -->
    <modal name="import_office" transition="pop-out" :width="600" height="auto">
      <importOffice></importOffice>
    </modal>
  </div>
</template>

<script>
import addOffice from "./add_office/add_office.vue";
import importOffice from "./import_office/import_office.vue";

export default {
  name: "Offices",
  components: {
    addOffice,
    importOffice
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    add_office: function() {
      this.$modal.show("add_office");
    },
    import_office: function() {
      this.$modal.show("import_office");
    },
    view_office: function(e) {
      var id = e.currentTarget.id;
      this.$router.push("/xv-admin/offices:" + id);
    }
  }
};
</script>
